<template>
  <v-card>
      <v-select
          v-model="search"
          :items="types"
          label="Select type"
          dense
          outlined
          clearable
        ></v-select>
    <v-data-table
    :headers="headers"
    :items="searchResult"
    class="elevation-1"
    :search="search!='none'?search:''"
    :loading="searching"
  >
      <template v-slot:items="props">
        <td class="text-xs-left" style="vertical-align:middle">{{ props.item.EiName }}</td>
        <td class="text-xs-center" style="vertical-align:middle">{{ props.item.EiType }}</td>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning" style="vertical-align:middle">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </v-data-table>
  </v-card>
</template>
<style lang="scss" scoped>
.center-table-text
  vertical-align: middle !important
</style>
<script>
export default {
    name:'SearchResultList',
    props:['searchResult','searching'],
    data(){
        return {
            search:"",
            types:['none','.flow','.gw','.ioc','.mms','.mote','.page','.tv'],
            headers: [
                {
                  text: 'Name',
                  align: 'left',
                  sortable: false,
                  value: 'EiName',
                },
                {
                    text:"Type",
                    align: 'center',
                    value:"EiType",
                    /*filter: value => {
                    if (!this.search) return true
                    return value == `.${this.search}`;
                }*/
                }
            ],
        }
    },
    methods:{
        filterByType(){
            
        }
    }
}
</script>